export default {
  success: '#2e7d32',
  info: '#0288d1',
  warning: '#ed6c02',
  error: '#d32f2f',
}
